module.exports = __webpack_public_path__ + "img/part-1-title.78aad7c2.png";